import { createApp } from 'vue';

import VueAxios from 'vue-axios';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axiosSetup from '@/plugins/axios';
import addIcons from '@/plugins/icons';

import App from './App.vue';
import router from './router';

import store from './store';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

axiosSetup();
addIcons();

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .mount('#app');
